import { Text } from '@/components/shared-components/BUI/Text'
import { ProjectLocationDisplayBlock as ProjectLocationDisplayBlockType } from '@/modules/templates/types/blueprint'

type Props = {
  block: ProjectLocationDisplayBlockType
}

export const ProjectLocationDisplayBlock: React.FC<Props> = ({ block }) => {
  return <Text>{block?.projectLocationName || 'No location selected'}</Text>
}
